/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  GetRiskPolicyApprovalRequest,
  GetRiskPolicyApprovalSecurity,
} from "../models/operations/getriskpolicyapproval.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildRiskGetApprovalQuery,
  prefetchRiskGetApproval,
  queryKeyRiskGetApproval,
  RiskGetApprovalQueryData,
} from "./riskGetApproval.core.js";
export {
  buildRiskGetApprovalQuery,
  prefetchRiskGetApproval,
  queryKeyRiskGetApproval,
  type RiskGetApprovalQueryData,
};

export type RiskGetApprovalQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * getRiskPolicyApproval risk
 *
 * @remarks
 * Get one tool approval request, including a preview of the call's arguments.
 */
export function useRiskGetApproval(
  request: GetRiskPolicyApprovalRequest,
  security?: GetRiskPolicyApprovalSecurity | undefined,
  options?: QueryHookOptions<
    RiskGetApprovalQueryData,
    RiskGetApprovalQueryError
  >,
): UseQueryResult<RiskGetApprovalQueryData, RiskGetApprovalQueryError> {
  const client = useGramContext();
  return useQuery({
    ...buildRiskGetApprovalQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * getRiskPolicyApproval risk
 *
 * @remarks
 * Get one tool approval request, including a preview of the call's arguments.
 */
export function useRiskGetApprovalSuspense(
  request: GetRiskPolicyApprovalRequest,
  security?: GetRiskPolicyApprovalSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    RiskGetApprovalQueryData,
    RiskGetApprovalQueryError
  >,
): UseSuspenseQueryResult<RiskGetApprovalQueryData, RiskGetApprovalQueryError> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildRiskGetApprovalQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setRiskGetApprovalData(
  client: QueryClient,
  queryKeyBase: [
    parameters: {
      id: string;
      gramKey?: string | undefined;
      gramSession?: string | undefined;
      gramProject?: string | undefined;
    },
  ],
  data: RiskGetApprovalQueryData,
): RiskGetApprovalQueryData | undefined {
  const key = queryKeyRiskGetApproval(...queryKeyBase);

  return client.setQueryData<RiskGetApprovalQueryData>(key, data);
}

export function invalidateRiskGetApproval(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: {
      id: string;
      gramKey?: string | undefined;
      gramSession?: string | undefined;
      gramProject?: string | undefined;
    }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "approvals", "get", ...queryKeyBase],
  });
}

export function invalidateAllRiskGetApproval(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "approvals", "get"],
  });
}
